import { Box } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import r77_fullFace from "../../assets/img/product/CheckID_R77/fullFace.png";
import SmartCard from "../../assets/img/product/SmartCard.png";
import RichPorts from "../../assets/img/product/RichPorts.png";
import nfc from "../../assets/img/product/NFC.png";
import size from "../../assets/img/product/size.png";
import qrCode from "../../assets/img/product/QR-code.png";
import {
  InfoDetail,
  OrtherProduct,
  TechnicalSpecifications,
} from "../../components/products";
import r77_1 from "../../assets/img/product/CheckID_R77/r77_1.jpg";
import r77_2 from "../../assets/img/product/CheckID_R77/r77_2.jpg";
import r77_3 from "../../assets/img/product/CheckID_R77/r77_3.jpg";

export const CheckIDR77 = () => {
  // set Title
  document.title = "Self-Service Terminal (CheckID -R77) | CheckID";

  const { t } = useTranslation();
  const r77Img = [r77_fullFace];
  const infoDetail = {
    header: "products.r77.infoDetail.header",
    model: "products.r77.infoDetail.model",
    description: "products.r77.infoDetail.description",
    function: [
      { name: "products.smartCard", image: SmartCard },
      { name: "products.USBInterface", image: RichPorts },
      { name: "NFC", image: nfc },
      { name: "43 inch", image: size },
      { name: "QRcode", image: qrCode },
    ],
  };
  const specification = [
    {
      item: "MAIN CONTROL  ",
      specification:
        "OS: Android /n 4G memory, 128G Storage /n 8 built-in USB, 1 TTL, 1 RS232, LVDS, HDMI interface, support WIFI /n 4G, Bluetooth function  ",
    },
    {
      item: "4G MODULE ",
      specification: "PCI-E Interface  ",
    },
    {
      item: "SPEAKER  ",
      specification: "With 2 Speakers  ",
    },
    {
      item: "DISPLAY  ",
      specification: "43” touch screen /n Resolution 1920*1080  ",
    },
    {
      item: "RECEIPT PRINTER  ",
      specification:
        "USB interface, paper width 58mm, paper roll diameter 50mm  ",
    },
    {
      item: "ID/PASSPORT READER  ",
      specification: "Support ID card and passport scan, USB interface  ",
    },
    {
      item: "ENCRYPTION KEYBOARD  ",
      specification:
        "RS232 interface, GM and PCI certified, /n Waterproof, dustproof, anti-riot/n Support DES, double DES, triple DES algorithm /n With self-destruct function/n With EPP shield  ",
    },
    {
      item: "BAR CODE READER  ",
      specification: "TTL communication, support bar code, and QR code  ",
    },
    {
      item: "DIMENSION  ",
      specification: "660W x 600D x 1870H(mm)  ",
    },
  ];
  return (
    <Box className="r77">
      <Box className="r77_info d-flex align-items-center">
        <Box>
          <h1 className="r77_info-header">{t("products.r77.header")}</h1>
          {/* <p className="r77_info-title">{t("products.r77.title")}</p> */}
        </Box>
        <img src={r77_fullFace} alt="" className="r77_info-img" />
      </Box>
      <InfoDetail classHeader="r77" showImg={r77Img} infoDetail={infoDetail} />
      <Box className="r77_features">
        <Box className="r77_features-comp r77_features-comp-left">
          <div className="r77_features-comp-img">
            <img src={r77_1} alt="" />
          </div>
          <Box className="r77_features-comp-info">
            <h4>{t("products.r77.features.0.header")}</h4>
            <p>{t("products.r77.features.0.body")}</p>
          </Box>
        </Box>
        <Box className="r77_features-comp r77_features-comp-left">
          <Box className="r77_features-comp-info">
            <h4>{t("products.r77.features.1.header")}</h4>
            <p>
              {t("products.r77.features.1.body")
                .split("/n")
                .map((item) => (
                  <>
                    {item}
                    <br />
                  </>
                ))}
            </p>
          </Box>
          <div className="r77_features-comp-img">
            <img src={r77_2} alt="" />
          </div>
        </Box>
        <Box className="r77_features-comp r77_features-comp-left">
          <div className="r77_features-comp-img r77_features-comp-img-bg">
            <img src={r77_3} alt="" />
          </div>
          <Box className="r77_features-comp-info">
            <h4>{t("products.r77.features.2.header")}</h4>
            <p>{t("products.r77.features.2.body")}</p>
          </Box>
        </Box>
      </Box>
      <TechnicalSpecifications
        classHeader="r77"
        specification={specification}
        type="type1"
      />
      <OrtherProduct classHeader="r77" />
    </Box>
  );
};
